const defaultStyles = {
primaryColor: '#E30613',
secondaryColor: '#232323',
backgroundColor: '#ffffff',
}
export default defaultStyles
